import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Grid, TextField } from '@mui/material';
import { useState } from 'react';

export function UploadManual({ open, onClose, manually, setManually, action, loading }) {
  const [error, setError] = useState(false);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={{ minWidth: 600 }}>
        <DialogTitle id="alert-dialog-title" sx={{ my: 3 }}>
          بارگذاری دستی ویدیو
        </DialogTitle>
        <DialogContent sx={{ height: '100%' }}>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                label="نام ویدیو"
                fullWidth
                value={manually?.manual?.videoName}
                onChange={(e) =>
                  setManually({ ...manually, manual: { ...manually?.manual, videoName: e.target.value } })
                }
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="آدرس ویدیو (Url)"
                fullWidth
                value={manually?.manual?.videoUrl}
                onChange={(e) =>
                  setManually({ ...manually, manual: { ...manually?.manual, videoUrl: e.target.value } })
                }
                error={error && manually?.manual?.videoUrl === ''}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="سایز ویدیو (مگابایت)"
                fullWidth
                value={manually.manual.size}
                type="number"
                onChange={(e) =>
                  setManually({ ...manually, manual: { ...manually.manual, size: e.target.valueAsNumber } })
                }
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>لغو</Button>
          <Button
            onClick={() => {
              if (manually.manual.videoUrl === '') {
                setError(true);
                return;
              }
              action();
            }}
            autoFocus
            variant="contained"
            sx={{ color: '#eee' }}
            disabled={loading}
          >
            بارگذاری
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
